import React, { useEffect, useState, useRef } from "react";
import Header from "./Header";
import fire from "./Firebase";
import "../App.css";
import { useReactToPrint } from "react-to-print";
import { toast } from "react-toastify";
import * as htmlToImage from "html-to-image";

function Try2() {
  const conponentPDF = useRef();
  const [usercertificate2, setusercertificate2] = useState([]);
  const domEl = useRef({});
  const downloadImage = async () => {
    const dataUrl = await htmlToImage.toJpeg(domEl.current);

    // download image
    const link = document.createElement("a");
    link.download = "html-to-img.jpeg";
    link.href = dataUrl;
    link.click();
  };

  useEffect(() => {
    fire
      .child(`certificates/${sessionStorage.getItem("lastname2")}`)
      .on("value", (sna) => {
        setusercertificate2([sna.val()]);
      });
  }, []);
  // const generatePDF = useReactToPrint({
  //   content: () => conponentPDF.current,
  //   documentTitle: "Userdata",
  //   onAfterPrint: () => toast("Not Saved"),
  // });

  return (
    <div>
      <Header />
      <div>
        {usercertificate2.map((datas) => {
          return (
            <>
              <div
                id="temp2"
                className="print"
                ref={domEl}
                style={{ textTransform: "uppercase" }}
              >
                <div className="containernew">
                  <div id="certificate">
                    <div className="cert">
                      <div className="cert-header">
                        <div className="cert-logo">
                          <div className="cert-logo-name">
                            HR School
                            <br />
                          </div>
                        </div>

                        <div className="cert-title">
                          CERTIFICATE OF COMPLETION
                        </div>
                        <div className="cert-no">
                          CERTIFIED {datas.Field} SPECIALIST
                        </div>
                      </div>

                      <div className="cert-content">
                        <div className="cert-label">
                          THIS IS TO CERTIFY THAT
                        </div>{" "}
                        <br />
                        <div className="cert-user">
                          <div className="cert-user-name">
                            NAME :-{datas.Gender} {datas.Name}
                          </div>{" "}
                          <br />
                          <div className="cert-user-info">
                            FATHER NAME :- {datas.Father}
                          </div>{" "}
                          <br />
                          <div className="cert-user-info">
                            COURSE DURATION :- {datas.Course} MONTHS
                          </div>{" "}
                          <br />
                          <div className="cert-user-info">
                            COURSE NAME :- {datas.Coursename}
                          </div>{" "}
                          <br />
                        </div>
                        <div className="cert-achievement">
                          THE BEAUTIFUL THING ABOUT LEARNING IS THAT NO ONE CAN
                          TAKE IT AWAY FROM YOU.
                        </div>{" "}
                        <br />
                        <br />
                        <div className="cert-signature">
                          <div>
                            HAS SUCCESSFULLY COMPLETED THE {datas.Coursename}{" "}
                            COURSE WITH LOKI SCHOOL
                          </div>{" "}
                          <br />
                          <div className="cert-signature-sign"></div>
                          <div>
                            <div style={{ fontWeight: "bold" }}>
                              WITH SCORE OF {datas.grade}
                            </div>{" "}
                            <br />
                            <div style={{ fontWeight: "bold" }}>Dated</div>{" "}
                            <br />
                            <br />
                          </div>
                          <div>
                            START DATE :- {datas.startdate}/{datas.startmonth}/
                            {datas.startyear}
                          </div>
                          <div>
                            END DATE :-{datas.enddate} /{datas.endmonth}/
                            {datas.endyear}
                          </div>
                        </div>
                      </div>

                      <div className="cert-footer">
                        <div className="cert-qr">
                          <div className="cert-qr-image"></div>
                        </div>
                        <div className="cert-qr-label">www.hrschool.com</div>
                      </div>
                    </div>
                  </div>
                </div>
                <center>
                  {" "}
                  <br />
                </center>
              </div>
              ;
            </>
          );
        })}
      </div>
      <center>
        {/* <button className="non-printable" onClick={() => generatePDF()}>
          Convert In PDF
        </button> */}
        <button onClick={downloadImage} style={{ color: "black" }}>
          Download Image
        </button>
      </center>
    </div>
  );
}

export default Try2;
